import { ClipboardTextIcon, UsersThreeIcon } from '@phosphor-icons/react';

const SolutionTabs = ({ activeTab, onChange }) => {
  return (
    <div className="bg-[var(--q3-surface-default)] border-l border-r border-b border-[var(--q3-stroke-light)] mx-2 flex flex-row flex-nowrap items-center gap-4 md:gap-6 px-3 md:px-6 overflow-x-auto">
      <div
        role="button"
        tabIndex={0}
        onClick={() => onChange('quizrr')}
        onKeyDown={(e) => e.key === 'Enter' && onChange('quizrr')}
        className={`flex flex-row items-center gap-2 py-3 cursor-pointer border-b-2 shrink-0 ${
          activeTab === 'quizrr' ? 'border-[var(--q3-accent-normal)]' : 'border-transparent'
        }`}
      >
        <ClipboardTextIcon
          size={20}
          className={activeTab === 'quizrr' ? 'text-[var(--q3-accent-normal)]' : 'text-[var(--q3-neutral-light)]'}
        />
        <span
          className={`text-xs md:text-sm font-semibold whitespace-nowrap ${
            activeTab === 'quizrr' ? 'text-[var(--q3-accent-normal)]' : 'text-[var(--q3-neutral-light)]'
          }`}
        >
          Quizrr Solution
        </span>
      </div>
      <div
        role="button"
        tabIndex={0}
        onClick={() => onChange('community')}
        onKeyDown={(e) => e.key === 'Enter' && onChange('community')}
        className={`flex flex-row items-center gap-2 py-3 cursor-pointer border-b-2 shrink-0 ${
          activeTab === 'community' ? 'border-[var(--q3-accent-normal)]' : 'border-transparent'
        }`}
      >
        <UsersThreeIcon
          size={20}
          className={activeTab === 'community' ? 'text-[var(--q3-accent-normal)]' : 'text-[var(--q3-neutral-light)]'}
        />
        <span
          className={`text-xs md:text-sm font-semibold whitespace-nowrap ${
            activeTab === 'community' ? 'text-[var(--q3-accent-normal)]' : 'text-[var(--q3-neutral-light)]'
          }`}
        >
          Community Solution
        </span>
        <span className="relative overflow-hidden bg-[var(--q3-danger-normal)] text-[var(--q3-neutral-default_inverted)] text-[11px] font-semibold px-2 py-0.5 rounded-full whitespace-nowrap shrink-0 after:pointer-events-none after:absolute after:inset-y-0 after:left-0 after:w-1/3 after:bg-gradient-to-r after:from-transparent after:via-white/70 after:to-transparent after:animate-badge-shimmer">
          New
        </span>
      </div>
    </div>
  );
};

export default SolutionTabs;
